import { firstValueFrom } from "rxjs";
import { FAILED_LOGIN_REDIRECT_URL } from "src/app/constants/auth.constants";
import { KeycloakService } from "src/app/services/keycloak.service";
import { environment } from "src/environments/environment";

export function keycloakInitializer(keycloakService: KeycloakService): () => Promise<void> {
  return async (): Promise<void> => {
    if (environment.offlineMode) {
      return;
    }

    try {
      await keycloakService.init();
      await keycloakService.login();
    } catch {
      const isAdvisor = await firstValueFrom(keycloakService.isAdvisorContext$);
      if (!isAdvisor) {
        globalThis.location.assign(FAILED_LOGIN_REDIRECT_URL);
      }
    }
  };
}
